import {IBaseUser} from './baseUser';
import {IMinimalFolder} from './minimalFolder';
import {nullServerUserFactory} from './serverUserResponseModel';
import Optional from './optional';

export interface IFolderTreeNode extends IMinimalFolder {
   Owner: IBaseUser;
   ParentFolder: Optional<IMinimalFolder>;
   SubFolders: IFolderTreeNode[];
}

export const nullFolderTreeNodeFactory = (initialData?: Partial<IFolderTreeNode>): IFolderTreeNode => Object.assign({
   Owner: nullServerUserFactory(),
   ParentFolder: null,
   Hash: '',
   Name: '',
   SubFolders: []
}, initialData);

export const folderInTargetFolderTree = (folderHash: string, targetFolder: IFolderTreeNode): boolean => {
   if (folderHash === targetFolder?.Hash) {
      return true;
   }

   if (targetFolder?.SubFolders?.some(sf => sf.Hash === folderHash)) {
      return true;
   }

   return targetFolder?.SubFolders?.some(sf => folderInTargetFolderTree(folderHash, sf));
};

export const replaceFolderInFolderTree = (folder: IFolderTreeNode, updatedFolder: IFolderTreeNode): IFolderTreeNode => {
   if (folder?.Hash === updatedFolder?.Hash) {
      return updatedFolder;
   }

   return {...folder, SubFolders: folder?.SubFolders?.map(subFolder => replaceFolderInFolderTree(subFolder, updatedFolder)) ?? []};
};

export const addFolderToFolderTree = (currentFolderTree: IFolderTreeNode, parentHash: string, newFolder: IFolderTreeNode): IFolderTreeNode => {
   if (currentFolderTree?.Hash === parentHash) {
      return {...currentFolderTree, SubFolders: [...currentFolderTree.SubFolders, newFolder]};
   }

   return {...currentFolderTree, SubFolders: currentFolderTree?.SubFolders?.map(subFolder => addFolderToFolderTree(subFolder, parentHash, newFolder)) ?? []};
};

export const removeFolderFromFolderTree = (folder: IFolderTreeNode, folderToRemoveHash: string): IFolderTreeNode => ({
   ...folder,
   SubFolders: folder?.SubFolders
      ?.filter(sub => sub.Hash !== folderToRemoveHash)
      .map(sub => removeFolderFromFolderTree(sub, folderToRemoveHash))
});

export const findFolderByHash = (folderTree: IFolderTreeNode, hash: string): IFolderTreeNode => {
   if (folderTree?.Hash === hash) {
      return folderTree;
   }

   for (const subFolder of folderTree.SubFolders) {
      const locatedFolder = findFolderByHash(subFolder, hash);
      if (locatedFolder) {
         return locatedFolder;
      }
   }

   return null;
};